// extracted by mini-css-extract-plugin
module.exports = {"cls":"components-userSearchQueryBuilder-queryBuilder__cls--3oubP"};